module.exports = __webpack_public_path__ + "background-error.a5449020ea4120c6bf24.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/images/default/background-error.jpg
// module id = ../../../../../src/assets/images/default/background-error.jpg
// module chunks = main